import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 10px;
  position: absolute;
  z-index: 100;
  right: 0px;
  background: white;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(191, 13, 62, 0.15);

  .react-datepicker {
    box-shadow: none;

    .react-datepicker__navigation {
      &.react-datepicker__navigation--next {
        border-left-color: #686868 !important;
      }

      &.react-datepicker__navigation--previous {
        border-right-color: #686868 !important;
      }
    }

    /* Mensual */
    .react-datepicker__month-container {
      &.react-datepicker__header {
        padding-top: 6px;

        &.react-datepicker-year-header,
        &.react-datepicker-month-header {
          color: #f02a2b !important;
        }
      }

      .react-datepicker__month {
        &.react-datepicker__monthPicker {
          display: flex;

          .react-datepicker__month-wrapper {
            .react-datepicker__month-text {
              width: 40px;
              margin: 1px;

              &.react-datepicker__month-text--keyboard-selected {
                background-color: #f02a2b !important;
              }
            }
          }
        }
      }
    }

    /* Trimestre */
    .react-datepicker__quarter-wrapper {
    }

    /* Anual */
    .react-datepicker__year--container {
      min-width: 170px;

      .react-datepicker__header {
        padding-top: 6px;

        &.react-datepicker-year-header {
          color: #f02a2b !important;
        }
      }

      .react-datepicker__year {
        .react-datepicker__year-wrapper {
          display: flex;

          .react-datepicker__year-text {
            width: calc(100% / 3 - 2px * 3);
            margin: 1px;

            &.react-datepicker__year-text--keyboard-selected {
              background-color: #f02a2b !important;
            }
          }
        }
      }
    }

    .react-datepicker__day--today {
      background-color: #ffa0bb !important;
    }
  }
`;

export const Filter = styled("div")`
  width: 100%;
  position: relative;
`;

export const Label = styled("label")``;

export const Input = styled("input")`
  align-items: center;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 38px;
  outline: 0 !important;
  position: relative;
  transition: all 100ms;
  box-sizing: border-box;
  font-size: 1rem;
  padding: 2px 8px;
  width: 100%;
`;

export const Line = styled("div")`
  height: 100%;
  flex: 1;
  flex-shrink: 0;
  width: 1px;
  margin: 0px 4px;
  background: #efefef;
`;

export const Tabs = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const Tab = styled("button")`
  border: 1px solid #f02a2b;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  ${({ isActive }) => (isActive ? `background-color: #f02a2b; color: white;` : `background-color: transparent; color: #f02a2b;`)}

  &:hover,
  &:focus,
  &:active {
    outline: 0px;
    border: 1px solid #f02a2b;
    background-color: #f02a2b;
    color: white;
  }
`;

export const TabContent = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 420px;
`;

export const DatepickerWrapper = styled("div")`
  background: rgb(223 223 223);
  padding: 3px 2px 0px;
  border-radius: 6px;
  text-align: center;
  color: black;
  font-weight: normal;
  font-size: 11px;
  text-transform: uppercase;
`;

export const Button = styled("button")`
  border: 0px;
  margin: 0px;
  padding: 0px;
  background: none;

  position: absolute;
  right: 6px;
  top: 27px;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: rgb(204 204 204);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #a7a7a7;
  }
`;
